import {
  GET_PROMPTS_REQUEST,
  GET_PROMPTS_SUCCESS,
  GET_PROMPTS_FAIL,
  ADD_PROMPT_REQUEST,
  ADD_PROMPT_SUCCESS,
  ADD_PROMPT_FAIL,
  EDIT_PROMPT_REQUEST,
  EDIT_PROMPT_SUCCESS,
  EDIT_PROMPT_FAIL,
  DELETE_PROMPT_REQUEST,
  DELETE_PROMPT_SUCCESS,
  DELETE_PROMPT_FAIL,
  GET_CHECK_PROMPT_OUTPUT,
  CLEAR_PROMPT_OUTPUT,
} from "../constant";

const initialState = {
  loading: true,
  data: [],
  prompt_output: {},
};

export const promptsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROMPTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PROMPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload],
      };
    case GET_PROMPTS_FAIL:
      return {
        ...state,
        loading: false,
      };
    case ADD_PROMPT_REQUEST:
      return {
        ...state,
        adding: true,
      };
    case ADD_PROMPT_SUCCESS:
      return {
        ...state,
        adding: false,
      };
    case ADD_PROMPT_FAIL:
      return {
        ...state,
        adding: false,
      };
    case EDIT_PROMPT_REQUEST:
      return {
        ...state,
        editing: true,
      };
    case EDIT_PROMPT_SUCCESS:
      return {
        ...state,
        editing: false,
      };
    case EDIT_PROMPT_FAIL:
      return {
        ...state,
        editing: false,
      };
    case DELETE_PROMPT_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case DELETE_PROMPT_SUCCESS:
      return {
        ...state,
        deleting: false,
        data: state.data.filter((prompt) => prompt.prompt_id !== action.payload),
      };
    case DELETE_PROMPT_FAIL:
      return {
        ...state,
        deleting: false,
      };
    case GET_CHECK_PROMPT_OUTPUT:
      return {
        ...state,
        prompt_output: action.payload,
      };
    case CLEAR_PROMPT_OUTPUT:
      return {
        ...state, prompt_output: {}
      }

    default:
      return state;
  }
};
